// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components usage; ESLint treated this as warn-level, not blocking
import styled from 'styled-components';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components usage; ESLint treated this as warn-level, not blocking
export const CardHeader = styled.div`
  margin-bottom: 16px;
`;

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components usage; ESLint treated this as warn-level, not blocking
export const CardTitle = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  @media screen and (min-width: 769px) {
    align-items: center;
  }

  .header-badge {
    background-color: #d5f3f9;
    color: #03698c;
    padding: 8px;
    font-size: 14px;
    font-weight: 700;
  }
`;

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components usage; ESLint treated this as warn-level, not blocking
export const ModalBody = styled.div`
  white-space: pre-line;
  margin-bottom: 40px;
`;

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components usage; ESLint treated this as warn-level, not blocking
export const StackedButtons = styled.div`
  display: flex;
  flex-direction: column;
`;
